import * as React from "react";
import Divider from "../divider";
import ProductItem from "../product-item";
import Loader from "../loader";
import CONSTS from "../../consts";
const SwiperJS = require('react-id-swiper');
const Swiper = SwiperJS.default;
export default class Suggestion extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const params = {
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            slidesPerView: 2,
            spaceBetween: 40,
            rebuildOnUpdate: true,
            breakpoints: {
                1100: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                780: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 10
                }
            }
        };
        const mobilesuggestions = this.props.suggestions.map((product, index) => {
            return React.createElement("div", { key: index },
                React.createElement(ProductItem, { key: index, country: product.Country, category: product.ConsumerCategory, liqType: product.ConsumerType, city: product.Region, title: product.Name, imgPath: `${CONSTS.STORAGEURL}/${CONSTS.PRODUCTCONTAINER}/${product.SKU ? product.SKU.trim() : "NotAvail"}.jpg`, sponsored: product.SponsoredSKU, id: product.DisplaySKU, madeInAlberta: product.MadeInAlberta }));
        });
        return (React.createElement("div", { className: "browse-location" },
            React.createElement(Divider, null, "You Might Also Like"),
            React.createElement("div", { className: "view-product-suggestion" },
                this.props.loadingSuggestions &&
                    React.createElement(Loader, null),
                this.props.suggestions.map((product, index) => {
                    return React.createElement(ProductItem, { key: index, country: product.Country, category: product.ConsumerCategory, liqType: product.ConsumerType, showWhereToBuy: true, hideShoppingControls: true, city: product.Region, title: product.Name, imgPath: `${CONSTS.STORAGEURL}/${CONSTS.PRODUCTCONTAINER}/${product.SKU ? product.SKU.trim() : "NotAvail"}.jpg`, sponsored: product.SponsoredSKU, id: product.DisplaySKU, madeInAlberta: product.MadeInAlberta, singlesPerUnit: product.SinglesPerUnit, size: product.Size });
                })),
            React.createElement("div", { className: "mobile-suggestions" },
                this.props.loadingSuggestions &&
                    React.createElement(Loader, null),
                React.createElement(Swiper, Object.assign({ shouldSwiperUpdate: true }, params), mobilesuggestions))));
    }
}
;
//# sourceMappingURL=suggestions.js.map